import React from "react";
import { CheckCircle2, Award, Sparkles } from "lucide-react";
import "./ProgramDetails.custom.css";

const CertificateAdvantages = ({ course }) => {
  const benefits = [
    "Certificate from yslearn Engineering, part of a top-ranked learning institution",
    "Integrate and scale GenAI efforts across various business functions",
    "Join a cohort of senior leaders to exchange insights and strategies",
    "Course completion certificate hosted on the yslearn portal",
    "Acquire an official learning path completion transcript",
  ];

  const certificateUrl = require("../../../assets/images/certificate_model.png"); 

  return (
    <section id="programadvantage" className="certificate-section border-t border-gray-100 bg-[#f8fafc]">
      <div className="certificate-container-wrapper">
        
        {/* Section Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto px-4">
          <span className="pd-badge mb-4 mx-auto">
            <Sparkles size={11} className="text-blue-500 animate-pulse" />
            yslearn Advantage
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
            {course.CourseName} Advantage
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            Accelerate your leadership journey with frameworks, functional use cases, and live instruction.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Certificate Preview mockup */}
          <div className="certificate-container">
            <div className="certificate-bg-accent" />
            <div className="certificate-img-wrapper">
              <div className="certificate-glare"></div>
              <img 
                src={certificateUrl} 
                alt="Program Certificate" 
                className="certificate-img"
              />
              <span className="certification-badge">
                <Award size={15} className="text-amber-400" />
                Verified Certificate
              </span>
            </div>
          </div>

          {/* Benefits List */}
          <div className="advantages-list-wrapper space-y-8 text-left">
            <h3 className="text-2xl font-bold text-gray-800 tracking-tight">
              Partnering With yslearn Engineering
            </h3>
            <div className="flex flex-col gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="advantage-item-row flex items-start gap-4 p-4 hover:bg-white rounded-2xl transition-all duration-200 hover:-translate-y-0.5 hover:shadow-sm border border-transparent hover:border-gray-100">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                    <CheckCircle2 size={16} className="stroke-[2.5]" />
                  </div>
                  <span className="text-sm font-bold text-gray-700 leading-normal mt-1">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificateAdvantages;

